<template>
  <div>
    <CompanyBasicInfo
      v-if="hasRole('company', 'ROLE_GET_COMPANY_ID')"
      :data="company"
    />

    <div class="box">
      <CompanyFinancialConfig v-if="hasRole('billing', 'ROLE_GET_FINANCIAL_CONFIG')" />
      <Incentives v-if="hasRole('billing', 'ROLE_GET_DISCOUNT_BY_COMPANY_ID')" class="mt-4" />
    </div>

    <!--
      Justificativa obrigatória para corridas
      Envio de recibo de corridas
      Limite diário de créditos para a empresa
    -->
    <UsagePoliciesPageContent
      v-if="hasRole('company', 'ROLE_GET_COMPANY_ID_CONFIG') || hasRole('company', 'ROLE_GET_COMPANY_ID_FINANCIALCONFIG')"
    />

    <AllowWebCall
      v-if="hasRole('company', 'ROLE_PUT_COMPANY_ID_ALLOWWEBCALL')"
      :data="allowWebCallData"
    />

    <AllowApiToken
      v-if="hasRole('company', 'ROLE_GET_TOKEN_LIST')"
    />
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import CompanyBasicInfo from 'components/company/CompanyBasicInfo'
import UsagePoliciesPageContent from 'components/usagePolicies/UsagePoliciesPageContent'
import CompanyFinancialConfig from 'components/company/CompanyFinancialConfig'
import Incentives from 'components/company/incentives'
import AllowWebCall from 'components/company/allowWebCall/AllowWebCall'
import AllowApiToken from 'components/company/allowApiToken/AllowApiToken'

export default {
  name: 'CompanyDetails',
  props: {
    company: {
      type: Object
    }
  },
  components: {
    CompanyBasicInfo,
    UsagePoliciesPageContent,
    CompanyFinancialConfig,
    Incentives,
    AllowWebCall,
    AllowApiToken
  },
  computed: {
    allowWebCallData () {
      return {
        companyId: this.company.id, // 之前传值错误，但是实际组件中没有用到这个值
        allowWebcall: this.company.allowWebcall
      }
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss">
.box {
  margin-bottom: 24px;
  padding: 0 16px;
}

.box__content {
  border: 1px solid $gray-2;
  background-color: #fff;
  max-width: 840px;
  transition: box-shadow .26s;
  border-radius: 4px;

  &:hover {

    @media (min-width: 992px) {
      box-shadow: 0 1px 6px rgba(#000, .25);
    }
  }
}

.box__header {
  padding: 16px 16px 0;
  color: $gray-7;
  display: flex;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  position: relative;
}

.box__header__edit {
  align-items: center;
  color: $accent;
  display: flex;
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: normal;
  text-decoration: none;

  .v-icon {
    font-size: 16px;
    margin-left: 4px;
  }
}

.subtitle__icon,
.box__title {
  display: inline-block;
  vertical-align: middle;
}

.subtitle__icon {
  margin-right: 10px;
  padding: 3px;
  width: 24px;
}

.box__title {
  font-size: 18px;
  font-weight: 800;
}

.box__subtitle,
.box__desc {
  margin-bottom: 0
}

.box__subtitle {
  font-size: 14px;
}

.box__desc {
  color: $gray-6;
  font-size: 12px;
}

.box__body {
  padding: 16px;
}
</style>
